import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import useThemeStyles from '../../../../../../../../../hooks/useThemeStyles';
import SceneHeaderRow from './SceneHeaderRow';
import WordCountPill from '../../../../../../../../../components/WordCountPill';

const SceneBlock = ({
  scene,
  sceneIndex,
  onDragStart,
  onDragEnd,
  isDraggable = true,
  onBeginSplitPlacement,
  splitPlacementActive = false,
  onOpenSceneActions,
  onOpenHistory,
}) => {
  const { colors, isDark } = useThemeStyles();

  const handleHeaderBarClick = (e) => {
    e.stopPropagation();
    if (e.target.closest('[data-scene-header-interactive]')) return;
    onOpenSceneActions?.(sceneIndex, scene);
  };

  return (
    <Box
      onClick={handleHeaderBarClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        width: '100%',
        py: 0.5,
        px: 1,
        borderRadius: 1,
        backgroundColor: isDark ? '#1e293b' : colors.paper.background,
        backgroundImage: isDark ? 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)' : 'none',
        border: `1px solid ${colors.border.subtle}`,
        transition: 'all 0.2s ease-in-out',
        cursor: onOpenSceneActions ? 'pointer' : 'default',
        '&:hover': {
          backgroundColor: isDark ? '#334155' : colors.background.surface,
          borderColor: colors.interactive.hover,
        },
      }}
    >
      <SceneHeaderRow
        scene={scene}
        sceneIndex={sceneIndex}
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
        isDraggable={isDraggable}
        onBeginSplitPlacement={onBeginSplitPlacement}
        splitPlacementActive={splitPlacementActive}
        onOpenSceneActions={onOpenSceneActions}
        onOpenHistory={onOpenHistory}
      />

      <Box component="span" data-scene-header-interactive sx={{ display: 'inline-flex' }}>
        <WordCountPill wordCount={scene.wordCount} />
      </Box>
    </Box>
  );
};

SceneBlock.propTypes = {
  scene: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    wordCount: PropTypes.number,
  }).isRequired,
  sceneIndex: PropTypes.number.isRequired,
  onDragStart: PropTypes.func.isRequired,
  onDragEnd: PropTypes.func.isRequired,
  isDraggable: PropTypes.bool,
  onBeginSplitPlacement: PropTypes.func,
  splitPlacementActive: PropTypes.bool,
  onOpenSceneActions: PropTypes.func,
  onOpenHistory: PropTypes.func,
};

SceneBlock.defaultProps = {
  isDraggable: true,
  splitPlacementActive: false,
  onBeginSplitPlacement: undefined,
  onOpenSceneActions: undefined,
  onOpenHistory: undefined,
};

export default SceneBlock;
